import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ToastController, AlertController, NavController, ModalController, LoadingController } from '@ionic/angular';
import { PouchService } from '../../services/pouch-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';
import { Router, NavigationEnd } from '@angular/router';
import { PreviousRouteService } from '../../services/previous-route-service';
import { SignupPage } from '../../signup/signup';
import { LoginPage } from 'src/app/login/login';
declare let firebase: any;

@Component({
  selector: 'header-buttons',
  templateUrl: './header-buttons.html',
  styleUrls: ['header-buttons.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderButtonsComponent {
  @Input() page = '';
  attendance: any;
  showattendance = false;
  update = {
    version: '1.0.0',
    url: '',
  };
  loading: any;
  root = false;
  businessAccounts = [];
  business = this.db.gsetting.username;

  constructor(public db: PouchService, public loadingCtrl: LoadingController, public modalCtrl: ModalController, private router: Router, public http: HttpClient, private previousRouteService: PreviousRouteService, public navCtrl: NavController, public toastController: ToastController, public alertCtrl: AlertController) {
    let prev = this.previousRouteService.getPreviousUrl();
    if (prev != undefined && prev != '/LoginUserPage') {
      this.root = false;
    } else {
      this.root = true;
    }
    this.businessAccounts = Object.keys(this.db.businessAccounts);
    if (!this.db.gsetting.username || this.businessAccounts.length == 0) {
      setTimeout(() => {
        this.awaitSync();
      }, 2000);
    }
    if (!this.db.user) {
      this.router.navigateByUrl('/LoginUserPage', {
        replaceUrl: true,
        state: { start: false },
      });
    }
  }

  async awaitSync() {
    if (localStorage.getItem('organization') != 'sarutech') {
      this.loading = await this.loadingCtrl.create({
        message: `${this.db.rename('This app requires cookies to be enabled')}...`,
      });
      this.db.presentToastAction('Please enable cookies to use this App and reload the page', 'toast-danger');
    } else {
      this.loading = await this.loadingCtrl.create({
        message: `${this.db.rename('Fetching Database Settings')}...`,
      });
    }
    this.loading.present();
    let count = 0;
    // Store the interval ID to clear it later
    const intervalId = setInterval(() => {
      if (this.db.gsetting.username) {
        this.db.addToBusinessAccounts();
        this.businessAccounts = Object.keys(this.db.businessAccounts);
        this.business = this.db.gsetting.username;
        this.loading.dismiss();
        this.db.clearLoadingDiv();
        clearInterval(intervalId); // Stop the interval when the condition is met
      }
      if (count > 10) {
        this.loading.dismiss();
        this.db.clearLoadingDiv();
        clearInterval(intervalId); // Stop the interval when the condition is met
        // send notification that user cannot use app without cookies
        let data = {
          product: this.db.appinfo.base_product,
          message: `User cannot use app without cookies in ${localStorage.getItem('organization')} organization from ${this.db.userinfo.country}`,
        };
        this.http.post('https://sarutech.com/api/app/whatsappZapier', data).subscribe();
        this.db.presentToastAction('Please enable cookies to use this App and reload the page', 'toast-danger');
      }
      count++;
    }, 1000);
  }

  open(page) {
    this.router.navigateByUrl(page);
  }

  exitDemo() {
    if (localStorage.getItem('global')) {
      localStorage.removeItem(this.db.appinfo.base_product + '_credentials');
      localStorage.removeItem('global');
      localStorage.removeItem(this.db.appinfo.base_product + '_user'); //logout user also
    } else {
      localStorage.removeItem(this.db.appinfo.product + '_credentials');
      localStorage.removeItem(this.db.appinfo.product + '_user'); //logout user also
    }
    this.router.navigateByUrl('/LoginPage');
  }

  help() {
    window.open('https://sarutech.com/documentation/' + this.page);
  }

  viewEntity(mode): void {
    this.router.navigateByUrl('/EntitysPage', { state: { mode: mode } });
  }

  selectDatabase($event) {
    if ($event.target.value == 'add') {
      this.createDatabase();
    } else if ($event.target.value == 'signin') {
      this.signin();
    } else {
      let credentials = {
        user_id: this.db.businessAccounts[$event.target.value].gsetting.username,
        password: this.db.businessAccounts[$event.target.value].gsetting.password,
        online: this.db.online,
        skip_setup: true,
      };
      localStorage.setItem(this.db.appinfo.product + '_credentials', JSON.stringify(credentials));
      localStorage.setItem(this.db.appinfo.product + '_user', JSON.stringify(this.db.businessAccounts[$event.target.value].user));
      window.location.reload();
    }
  }

  async signin() {
    let modal = await this.modalCtrl.create({
      component: LoginPage,
      componentProps: {
        type: 'add',
      },
    });
    modal.onDidDismiss().then(async (res) => {
      this.business = this.db.gsetting.username;
    });
    return await modal.present();
  }

  async createDatabase() {
    let modal = await this.modalCtrl.create({
      component: SignupPage,
      componentProps: {
        type: 'add',
      },
    });
    modal.onDidDismiss().then(async (res) => {
      this.business = this.db.gsetting.username;
    });
    return await modal.present();
  }

  toggleMenu() {
    this.db.showpages = !this.db.showpages;
  }
  async logout() {
    if (this.db.untranslated.length > 0) {
      this.http.post('https://sarutech.com/api/app/translate', { words: this.db.untranslated }).toPromise();
    }
    let user = this.db.user;
    const alert = await this.alertCtrl.create({
      header: this.db.rename('Sign Out of this Account?', this.db.language),
      message: `<p>${this.db.rename(`Please Take note of your username and password before you Sign Out`)} </p><p> ${this.db.rename(`Username`)}: ${user.username} </p><p> ${this.db.rename(`Password`)}: ${user.password} </p>`,
      buttons: [
        {
          text: this.db.rename('Cancel'),
          role: 'cancel',
        },
        {
          text: this.db.rename('Confirm'),
          handler: () => {
            if (localStorage.getItem('global')) {
              localStorage.removeItem(this.db.appinfo.base_product + '_user');
            } else {
              localStorage.removeItem(this.db.appinfo.product + '_user');
            }
            this.router.navigateByUrl('/LoginUserPage', {
              replaceUrl: true,
              state: { start: false },
            });
          },
        },
      ],
    });
    alert.present();
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  async presentToastX(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      buttons: [
        {
          text: 'Reload',
          role: 'cancel',
          handler: () => {
            window.location.reload();
          },
        },
      ],
      //showCloseButton: true,
      //dismissOnPageChange: true,
      //closeButtonText: 'Reload',
      cssClass: type,
    });
    await toast.present();
    const { role } = await toast.onDidDismiss();
  }
}
